<template>
  <Dialog :visible="visible" @update:visible="(v) => emit('update:visible', v)" modal header="إضافة قسم جديد" :style="{ width: '420px' }">
    <div class="add-section-list">
      <button
        v-for="option in options"
        :key="option.key"
        type="button"
        class="add-section-item"
        :disabled="option.exists || creating"
        @click="choose(option)"
      >
        <span class="add-section-item__icon">{{ option.icon }}</span>
        <span class="add-section-item__label">{{ option.label }}</span>
        <span v-if="option.exists" class="add-section-item__badge">مضاف بالفعل</span>
        <i v-else class="pi pi-plus add-section-item__add"></i>
      </button>
    </div>
  </Dialog>
</template>

<script setup>
import { computed, ref } from 'vue';
import Dialog from 'primevue/dialog';
import Swal from 'sweetalert2';
import { useHomepageStore } from '@/stores/useHomepageStore';

const props = defineProps({
  visible: { type: Boolean, default: false },
});
const emit = defineEmits(['update:visible', 'created']);

const store = useHomepageStore();
const creating = ref(false);

// Mirrors the canonical section catalog seeded on the backend
// (App\Support\HomepageDefaults) — only these types/keys are ever rendered
// by the public site, so only these can be added here.
const CATALOG = [
  { key: 'header', type: 'header', icon: '🖥️', label: 'الهيدر' },
  { key: 'hero', type: 'hero', icon: '🏠', label: 'الترحيب / Hero' },
  { key: 'quick_access', type: 'quick_access', icon: '⚡', label: 'الوصول السريع' },
  { key: 'academic_systems', type: 'academic_systems', icon: '🎓', label: 'الأنظمة الدراسية' },
  { key: 'academic_years_products', type: 'home_products', icon: '📅', label: 'السنوات الدراسية' },
  { key: 'courses_products', type: 'home_products', icon: '📚', label: 'الكورسات' },
  { key: 'statistics', type: 'statistics', icon: '📈', label: 'الإحصائيات' },
  { key: 'testimonials', type: 'testimonials', icon: '💬', label: 'آراء الطلاب' },
  { key: 'cta', type: 'cta', icon: '🚀', label: 'دعوة للتسجيل' },
  { key: 'footer', type: 'footer', icon: '🦶', label: 'الفوتر' },
];

const options = computed(() =>
  CATALOG.map((entry) => ({
    ...entry,
    exists: store.sections.some((s) => s.key === entry.key),
  })),
);

async function choose(option) {
  if (option.exists || creating.value) return;
  creating.value = true;
  try {
    const section = await store.createSection({ key: option.key, type: option.type });
    emit('update:visible', false);
    emit('created', section);
  } catch (e) {
    const message = e?.response?.data?.message || 'تعذر إضافة القسم';
    Swal.fire({ icon: 'error', title: message });
  } finally {
    creating.value = false;
  }
}
</script>

<style scoped>
.add-section-list { display: flex; flex-direction: column; gap: .5rem; }
.add-section-item {
  display: flex; align-items: center; gap: .75rem;
  border: 1px solid var(--border, #e5e7eb); background: #fff; border-radius: 10px;
  padding: .75rem .9rem; cursor: pointer; text-align: right; font-size: .92rem; font-weight: 600;
  transition: background .15s, border-color .15s;
}
.add-section-item:hover:not(:disabled) { background: rgba(5,22,41,.04); border-color: var(--primary, #051629); }
.add-section-item:disabled { cursor: not-allowed; opacity: .55; }
.add-section-item__icon { font-size: 1.25rem; }
.add-section-item__label { flex: 1; }
.add-section-item__add { color: var(--primary, #051629); }
.add-section-item__badge { font-size: .72rem; font-weight: 600; color: #9ca3af; }
</style>
